import { Helmet } from "react-helmet-async";

const SITE_NAME = "Commercial Client Acquisition, LLC";
const DEFAULT_DESC =
  "Commercial Client Acquisition (CCA) builds a predictable commercial insurance pipeline for independent agencies through disciplined systems, standardized processes, and quality assurance.";
const BASE_KEYWORDS =
  "Commercial Insurance Pipeline Development, commercial prospecting, insurance sales pipeline, agency growth, producer prospecting";

function getOrigin() {
  if (typeof window !== "undefined" && window.location) return window.location.origin;
  return "";
}

export default function Seo({ title, description, path = "", keywords, jsonLd }) {
  const fullTitle = title ? `${title} — CCA Pipeline Development` : `${SITE_NAME} | Commercial Insurance Pipeline Development`;
  const desc = description || DEFAULT_DESC;
  const url = `${getOrigin()}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="keywords" content={keywords ? `${keywords}, ${BASE_KEYWORDS}` : BASE_KEYWORDS} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
